import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import ReactTooltip from 'react-tooltip'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import {
  YesNo,
} from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
class IyvListSriUssifIcon extends Component {
  static propTypes = {
    ussif: PropTypes.string, // ugh
    sri: PropTypes.string,
    id: PropTypes.string,
    mobile: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
    //
    const isUssif = convert.float(props.ussif) === 1.5
    const isSri = convert.boolean(props.sri)
    const fundSriTooltip = isSri ?
      format.tooltipHtml('Reports a Sustainability Mandate to Morningstar') :
      format.tooltipHtml('No Sustainability Mandate')
    //
    this.state = {
      isUssif,
      isSri,
      fundSriTooltip
    }
  }
  //
  render() {
    const ussifLogo = require('../../../static/images/ussif-icon.png')
    //
    return <div styleName='sri-wrapper'>
      <div
        style={{ display:'inline-block' }}
        data-multiline
        data-effect={'solid'}
        data-tip={this.state.fundSriTooltip}
        data-html
        data-place='bottom'
        data-for='sri-icon-tooltip'
      >
        <YesNo yes={this.state.isSri} />
      </div>
      <ReactTooltip id='sri-icon-tooltip'/>

      { /* if there's a US-SIF badge: show an image */
        this.state.isUssif ?
          (
            <img styleName='ussif-badge-img'
              src={ussifLogo}
              alt={
                'Member of The Forum for Sustainable and ' +
                  'Responsible Investment'
              }
              data-multiline
              data-effect={'solid'}
              data-tip={
                format.tooltipHtml(
                  'Member of US-SIF, the Forum for Sustainable ' +
                    'and Responsible Investment'
                )
              }
              data-html
              data-place='bottom'
              data-for={'ussif-' + this.props.id}
            />
          ) :
          null
        }
      <ReactTooltip id={'ussif-' + this.props.id}/>
    </div>
  }
}


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListTdSriUssif extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickShareclass: PropTypes.func,
    mobile: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
    //
    const isUssif = convert.float(props.shareclass.ussif) === 1.5
    const isSri = convert.boolean(props.shareclass.socially_responsible_fund)
    const fundSriTooltip = isSri ?
      format.tooltipHtml('Reports a Sustainability Mandate to Morningstar') :
      format.tooltipHtml('No Sustainability Mandate')
    //
    this.state = {
      isUssif,
      isSri,
      fundSriTooltip
    }
  }
  //
  render() {
    const ussifLogo = require('../../../static/images/ussif-icon.png')
    //
    return <td
      styleName='col'
      onClick={
        this.props.mobile ?
          () => { } :
          this.props.clickShareclass(this.props.shareclass)
      }
    >
      <IyvListSriUssifIcon
        ussif={this.props.shareclass.ussif}
        sri={this.props.shareclass.socially_responsible_fund}
        id={this.props.shareclass.investment_vehicle_id}
      />
    </td>
  }
}